import { UserService } from 'spc/services/user.service';
import { ApiService } from 'spc/shared/api/api.service';

let ctrl;
class VenueSuggestionFormController {
  isPremiumUser: boolean;
  constructor(
    $rootScope,
    $location,
    $user: UserService,
    unwrapError,
    private $api: ApiService,
    VenueSearchMapService,
  ) {
    'ngInject';
    ctrl = this;
    ctrl.$rootScope = $rootScope;
    ctrl.$user = $user;
    ctrl.unwrapError = unwrapError;
    ctrl.submitted = false;
    ctrl.error = false;
    ctrl.$location = $location;
    ctrl.mapService = VenueSearchMapService;
  }

  $onInit() {
    ctrl.$user.isPremiumMember()
    .then((res) => {
      ctrl.isPremiumUser = res;
    })
    .catch(ctrl.unwrapError);
  }

  submitVenueQuery(venue:
    {
      name: string,
      city: string,
      userEmail?: string
    } = {
      name: '',
      city: '',
    }) {
    this.$api.VenueQueries.create({
      venueQuery: {
        name: venue.name,
        city: ctrl.search.location,
        email: venue.userEmail
      }
    }).then(function (response) {
      ctrl.submitted = true;
      ctrl.error = false;
    }).catch(function (error) {
      ctrl.error = true;
      ctrl.unwrapError;
    });
  }

  disableViewTransition() {
    ctrl.$rootScope.disableViewTransition();
  }

  redrawMarkers() {
    ctrl.mapService.drawMarkers(ctrl.search.venues);
  }
  resetPage(navigateToUpgrade = false) {
    if (navigateToUpgrade) {
      window.open('/upgrade', '_blank');
    }
    if (ctrl.calledFrom === 'list-modal') {
      ctrl.submitted = false;
      ctrl.error = false;
      ctrl.onHideForm();
      return;
    }
    ctrl.disableViewTransition();
    ctrl.$location.search('page', null);
    ctrl.submitted = false;
    ctrl.error = false;
    let resetFilter = true;
    if ( ctrl.calledFrom === 'add-space' ) {
      resetFilter = false;
    }
    return ctrl.search.reset(resetFilter)
      .then(ctrl.redrawMarkers)
      .catch(ctrl.unwrapError);
  }
}
const venueSuggestionFormComponent = {
  template: require('./venue-suggestion-form.jade'),
  bindings: {
    search: '<',
    calledFrom: '<',
    onHideForm: '&'
  },
  controller: VenueSuggestionFormController
};

export default venueSuggestionFormComponent;

